import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

// Suppress benign ResizeObserver notifications from showing in CRA/webpack error overlay
const isResizeObserverError = (msg) => {
  return (
    typeof msg === "string" &&
    (msg.includes("ResizeObserver loop") || msg.includes("ResizeObserver loop completed"))
  );
};

window.addEventListener(
  "error",
  (e) => {
    if (isResizeObserverError(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  },
  true
);

window.addEventListener(
  "unhandledrejection",
  (e) => {
    if (e.reason && isResizeObserverError(e.reason.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true
);

ReactDOM.createRoot(document.getElementById("root")).render(
  <GoogleOAuthProvider clientId={googleClientId}>
    <App />
  </GoogleOAuthProvider>
);

reportWebVitals();
